/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_publish_item_button17 = /** @type {(inputs: {}) => string} */ () => {
	return `Publish Now`
};

const fr_publish_item_button17 = /** @type {(inputs: {}) => string} */ () => {
	return `Publier maintenant`
};

const de_publish_item_button17 = /** @type {(inputs: {}) => string} */ () => {
	return `Jetzt veröffentlichen`
};

const es_publish_item_button17 = /** @type {(inputs: {}) => string} */ () => {
	return `Publicar ahora`
};

const it_publish_item_button17 = /** @type {(inputs: {}) => string} */ () => {
	return `Pubblica ora`
};

const ar_publish_item_button17 = /** @type {(inputs: {}) => string} */ () => {
	return `انشر الآن`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const publish_item_button17 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.publish_item_button17(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("publish_item_button17", locale)
	if (locale === "en") return en_publish_item_button17(inputs)
	if (locale === "fr") return fr_publish_item_button17(inputs)
	if (locale === "de") return de_publish_item_button17(inputs)
	if (locale === "es") return es_publish_item_button17(inputs)
	if (locale === "it") return it_publish_item_button17(inputs)
	return ar_publish_item_button17(inputs)
};
export { publish_item_button17 as "PUBLISH_ITEM_BUTTON" }